import React, { useRef, useState } from 'react';
import { Button, message, Popconfirm } from 'antd';
// import type { ColumnsType } from 'antd/es/table/interface';
import type { ActionType, ProColumns } from '@ant-design/pro-table';
import { ProTable } from '@ant-design/pro-table';
import './index.less';
import { deleteProvider, getProviders, updateVersionByNames } from '@/services/flexGroup';
import EditModal from './EditModal';
import AddModal from './AddModal';
import CodeFieldModal, { CodeFiedProps } from './CodeFieldModal';

export interface ProviderType {
  id: string;
  accessKey: string;
  accessSecret: string;
  imageId: string;
  instanceStatus: string;
  instanceChargeType: string;
  instanceType: string;
  name: string;
  networkChargeType: string;
  networkType: string;
  providerType: string;
  region: string;
  securityGroupIds: string;
  tags: string;
  type: string;
  userData: string;
  zoneConfig: string;
  providerName: string;
  upgradeTypes: string;
  publicIp: boolean;
}

interface SearchType {
  name: string;
}

// const data = new Array<GroupsType>(20).fill(2 as any).map((item, index) => ({
//     id: 'x' + index,
//     max: 6,
//     current: Number((6 - 20 / (index + 5)).toFixed(0)),
//     abortStrategy: 'aaa',
//     creatTime: '2022-10-1',
//     expected: 3,
//     name: 'ccc' + index,
//     provider: 'ali cloud',
//     providerName: 'ali cloud',
//     standBy: 1,
//     status: 'working',
//     userId: 'aaa',
//     userName: 'Ballack',
//     workStatusCallbackUrl: 'https://transfer-dev.api.patternx.gemdale.com//v1/transfer/ecs/callback'
// }))

const Provider: React.FC = () => {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const currentEditItem = useRef<ProviderType | null>(null);
  const currentCodeItem = useRef<CodeFiedProps>();

  const actionRef = useRef<ActionType>();

  const [addModalVisible, setAddModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);

  const onEdit = (record: ProviderType) => {
    setEditModalVisible(true);
    currentEditItem.current = record;
  };

  const onEditModalCancel = () => {
    setEditModalVisible(false);
  };

  const onAddModalCancel = () => {
    setAddModalVisible(false);
  };

  const onDelete = (id: string) => {
    deleteProvider(id).then((res) => {
      if (res?.data.code === 'SUCCESS') {
        message.success('删除成功');
        actionRef.current?.reload();
        actionRef.current?.clearSelected && actionRef.current?.clearSelected();
      }
    });
  };

  const onUpdate = (name: string) => {
    updateVersionByNames([name]).then((res) => {
      if (res?.data.code === 'SUCCESS') {
        message.success('更新成功');
      }
    });
  };

  const columns: ProColumns<ProviderType>[] = [
    {
      title: 'id',
      dataIndex: 'id',
      valueType: 'text',
      search: false,
      width: 160,
    },
    {
      title: '名称',
      dataIndex: 'name',
      valueType: 'text',
      colSize: 1,
      width: 200,
    },
    {
      title: '供应商',
      dataIndex: 'type',
      search: false,
      width: 100,
    },
    {
      title: '镜像id',
      dataIndex: 'imageId',
      valueType: 'text',
      search: false,
      width: 200,
    },
    {
      title: '实例收费类型',
      dataIndex: 'instanceChargeType',
      valueType: 'text',
      search: false,
      width: 160,
    },
    {
      title: '实例类型',
      dataIndex: 'instanceType',
      valueType: 'text',
      search: false,
      // width: 640,
    },
    {
      title: '网络计费类型',
      dataIndex: 'networkChargeType',
      valueType: 'text',
      search: false,
      width: 220,
    },
    {
      title: '网络类型',
      dataIndex: 'networkType',
      valueType: 'text',
      search: false,
      width: 120,
    },
    {
      title: '区域',
      dataIndex: 'region',
      search: false,
      width: 120,
    },
    {
      title: '安全组',
      dataIndex: 'securityGroupIds',
      search: false,
      width: 180,
    },
    {
      title: '实例tag信息',
      dataIndex: 'tags',
      search: false,
      render: (_, entity) => (
        <div className="view">
          <div className="content">{entity.tags || '-'}</div>
          {entity.tags && entity.tags !== '' && (
            <div className="option" onClick={() => onView({ type: 'json', codeStr: entity.tags })}>
              查看
            </div>
          )}
        </div>
      ),
      // valueType: 'jsonCode'
      width: 270,
    },
    {
      title: '提供给实例使用的用户数据',
      dataIndex: 'userData',
      search: false,
      render: (_, entity) => (
        <div className="view">
          <div className="content">{entity.userData || '-'}</div>
          {entity.userData && entity.userData !== '' && (
            <div
              className="option"
              onClick={() => onView({ type: 'code', codeStr: entity.userData })}
            >
              查看
            </div>
          )}
        </div>
      ),
      // valueType: 'code'
      width: 270,
    },
    {
      title: 'zone配置信息',
      dataIndex: 'zoneConfig',
      search: false,
      render: (_, entity) => (
        <div className="view">
          <div className="content">{entity.zoneConfig || '-'}</div>
          {entity.zoneConfig && entity.zoneConfig !== '' && (
            <div
              className="option"
              onClick={() => onView({ type: 'json', codeStr: entity.zoneConfig })}
            >
              查看
            </div>
          )}
        </div>
      ),
      // valueType: 'jsonCode'
      width: 270,
    },
    {
      title: '版本',
      dataIndex: 'version',
      search: false,
      width: 270,
    },
    {
      title: '是否配置公网ip',
      dataIndex: 'publicIp',
      search: false,
      render: (_, entity) => (
        <div className="view">
          <div className="content">{entity.publicIp ? '是' : '否' || '-'}</div>
          {console.log('publicIp', _, entity)}
        </div>
      ),
      // valueType: 'jsonCode'
      width: 130,
    },
    {
      title: '操作',
      valueType: 'option',
      fixed: 'right',
      // width: 210,
      render: (_, entity) => [
        console.log('providerEntity', entity),
        <div className="optionButton" key="edit" onClick={() => onEdit(entity)}>
          编辑
        </div>,
        <Popconfirm
          title={'确定删除吗?'}
          onConfirm={() => onDelete(entity.id)}
          key="delete"
          className="deleteConfirm"
        >
          <div className="optionButton">删除</div>
        </Popconfirm>,
        <div className="optionButton" key="update" onClick={() => onUpdate(entity.name)}>
          更新版本
        </div>,
      ],
    },
  ];

  const onView = (code: CodeFiedProps) => {
    currentCodeItem.current = code;
    setViewModalVisible(true);
  };

  const onAdd = () => {
    setAddModalVisible(true);
  };

  const onViewModalCancel = () => {
    setViewModalVisible(false);
  };

  return (
    <div className="flexGroup">
      <ProTable<ProviderType, SearchType>
        columns={columns}
        defaultSize="large"
        scroll={{ x: 3800 }}
        rowSelection={false}
        rowKey={(record) => record.id}
        tableLayout={'auto'}
        actionRef={actionRef}
        toolBarRender={() => [
          <Button key="add" type="primary" onClick={onAdd}>
            新增供应商
          </Button>,
        ]}
        pagination={{
          pageSizeOptions: ['10', '20', '30'],
          defaultPageSize: 10,
          showSizeChanger: true,
        }}
        search={{ span: 8 }}
        request={async (
          params: SearchType & {
            current?: number | undefined;
            pageSize?: number | undefined;
            pageIndex?: number | undefined;
          },
          sort,
          filter,
        ) => {
          params.pageIndex = params.current;
          const data = await getProviders(params);
          return {
            data: data?.data.records,
            success: data?.success,
            total: data?.data.total,
          };
        }}
      />
      {editModalVisible && (
        <EditModal
          visible={editModalVisible}
          record={currentEditItem.current}
          refreshTable={() => {
            actionRef.current?.reload();
          }}
          onCancel={onEditModalCancel}
        />
      )}
      {addModalVisible && (
        <AddModal
          visible={addModalVisible}
          onCancel={onAddModalCancel}
          refreshTable={() => {
            actionRef.current?.reload();
          }}
        />
      )}
      {viewModalVisible && (
        <CodeFieldModal
          visible={viewModalVisible}
          onCancel={onViewModalCancel}
          code={currentCodeItem.current}
        />
      )}
    </div>
  );
};

export default Provider;
